<header class="uls ul-card">
  @if (details(); as details) {
    @if (!isEditing()) {
      <comp-card-header>
        <span headline class="page-title">{{ details.name }}</span>
        <div action-items class="prime-action-bar">
          <button comp-button type="button" (click)="editRequested.emit()">
            <i comp-icon>edit</i>
            <span>{{ 'revisions.edit' | translate }}</span>
          </button>
        </div>
      </comp-card-header>
      <p class="preserve-line-breaks">{{ details.description }}</p>
    } @else {
      <comp-card-header>
        <span headline class="page-title">{{ 'general.edit' | translate }} {{ details.name }}</span>
      </comp-card-header>
      <form class="ul-form product-edit-form" [formGroup]="form" (ngSubmit)="onSave()">
        <p class="form-field">
          <mat-form-field class="ul-single-line-input" appearance="outline" [floatLabel]="'always'">
            <mat-label>{{ 'model.product.properties.name' | translate }}</mat-label>
            <input
              compAutofocus
              formControlName="name"
              matInput
              required
              [errorStateMatcher]="dirtyErrorStateMatcher"
              (input)="formService.clearError(form, 'name', 'uniqueness'); onModelChanged()"
              (blur)="validateUniqueness()"
            />
            @if (form.get('name')?.hasError('uniqueness')) {
              <mat-error>
                {{ 'general.validation.uniqueness' | translate }}
              </mat-error>
            }
            @if (form.get('name')?.hasError('required')) {
              <mat-error>
                {{ 'general.validation.required' | translate }}
              </mat-error>
            }
            @if (form.get('name')?.hasError('maxlength')) {
              <mat-error>
                {{
                  'general.validation.maxlength'
                    | translate: { length: form.get('name')?.getError('maxlength')?.requiredLength }
                }}
              </mat-error>
            }
          </mat-form-field>
        </p>
        <p class="form-field">
          <mat-form-field class="ul-textarea-field" appearance="outline" [floatLabel]="'always'">
            <mat-label>{{ 'model.product.properties.description' | translate }}</mat-label>
            <textarea
              formControlName="description"
              matInput
              cdkTextareaAutosize
              (input)="onModelChanged()"
            ></textarea>
          </mat-form-field>
        </p>
        <div class="button-bar">
          <button comp-button="secondary" type="button" (click)="cancelRequested.emit()">
            {{ 'general.cancel' | translate }}
          </button>
          <button comp-button type="submit" [disabled]="isSubmitting() || form.invalid">
            {{ 'general.save' | translate }}
          </button>
        </div>
      </form>
    }
  } @else {
    <p>Loading...</p>
  }
</header>
